import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Person, BoxArrowRight } from "react-bootstrap-icons";
import { jwtDecode } from "jwt-decode";

import {
  Account,
  AccountBlock,
  AccountDetailsBlock,
  AccountEmail,
  AccountFullName,
  AccountWrapper,
  DropDownIcon,
  NameEmailWrapper,
  Theme,
  ThemeBlock,
  ThemeLabel,
  UserDetailsWrapper,
  UserMenu,
  UserMenuWrapper,
  UserName,
  UserRole,
} from "./styles";
import { signOut } from "../../store/slices/auth";
import { useOutsideClick } from "../../hooks/useOutsideClick";
import { useNavigate } from "react-router-dom";
import { getTheme, getUser } from "../../store/selectors/main";
import { AccountDto } from "../../models/Authentication";
// import { setTheme } from "../../store/slices/appConfig";
import { setTheme } from "../../store/slices/appConfig";
import { getProfiles } from "../../store/selectors/profiles";
import { requestProfile } from "../../store/slices/profiles";
import { AvatarCard } from "../AvatarCard";

export const UserDetails = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<any>(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(getUser);
  const profile = useSelector(getProfiles);
  const [account, setAccount] = useState<AccountDto | undefined>();
  const currentTheme = useSelector(getTheme);
  const [theme, setLocalTheme] = useState<string | undefined>(currentTheme);
  const darkModeQuery = window.matchMedia("(prefers-color-scheme: dark)");

  useOutsideClick(menuRef, () => {
    setMenuOpen(false);
  });
  useEffect(() => {
    if (user?.accessToken) {
      const account: AccountDto = jwtDecode(user?.accessToken);
      setAccount(account);
    }
  }, [user]);

  useEffect(() => {
    if (!profile.id && user?.accessToken) {
      dispatch(requestProfile());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile.id, user?.accessToken]);

  useEffect(() => {
    if (currentTheme === "dark") {
      document.body.classList.add("dark-theme");
    }
  }, [currentTheme]);

  const initials = useMemo(() => {
    let initials = account?.email?.charAt(0);
    if (profile?.firstName?.length || profile?.lastName?.length) {
      return `${profile.firstName?.charAt(0) || ""}${
        profile.lastName?.charAt(0) || ""
      }`;
    }
    if (account?.firstName?.length || account?.lastName?.length) {
      initials =
        (account?.firstName?.charAt(0) || "") +
        (account?.lastName?.charAt(0) || "");
    }
    if (account?.name?.length) {
      initials = account?.name?.charAt(0);
    }
    return initials?.toUpperCase();
  }, [
    account?.email,
    account?.firstName,
    account?.lastName,
    account?.name,
    profile?.firstName,
    profile?.lastName,
  ]);

  const setCurentTheme = (localTheme: string) => {
    setLocalTheme(localTheme);
    let theme = localTheme;
    if (localTheme === "system") {
      theme = darkModeQuery.matches ? "dark" : "light";
    }
    dispatch(setTheme(theme as "dark" | "light"));
    if (theme === "dark") {
      document.body.classList.add("dark-theme");
    } else {
      document.body.classList.remove("dark-theme");
    }
  };

  return (
    <UserMenuWrapper ref={menuRef}>
      <AvatarCard avatar={profile?.avatar} initials={initials} />
      <UserDetailsWrapper onClick={() => setMenuOpen(!menuOpen)}>
        <NameEmailWrapper>
          <UserName>{`${profile.firstName || ""} ${
            profile.lastName || ""
          }`}</UserName>
          <UserRole>{profile?.email || ""}</UserRole>
        </NameEmailWrapper>
        <DropDownIcon $open={menuOpen} />
      </UserDetailsWrapper>
      {menuOpen && (
        <UserMenu $open={menuOpen}>
          <ul>
            <li>
              <AccountWrapper>
                <Account>Account</Account>
                <AccountBlock>
                  <AvatarCard avatar={profile?.avatar} initials={initials} />
                  <AccountDetailsBlock>
                    <AccountFullName>{`${profile?.firstName || ""} ${
                      profile?.lastName || ""
                    }`}</AccountFullName>
                    <AccountEmail>{profile?.email || ""}</AccountEmail>
                  </AccountDetailsBlock>
                </AccountBlock>
              </AccountWrapper>
            </li>
            <li>
              <AccountWrapper>
                <Theme>Theme</Theme>
                <ThemeBlock>
                  <ThemeLabel
                    $selected={theme === "light"}
                    onClick={() => {
                      setCurentTheme("light");
                    }}
                  >
                    Light
                  </ThemeLabel>
                  <ThemeLabel
                    $selected={theme === "dark"}
                    onClick={() => {
                      setCurentTheme("dark");
                    }}
                  >
                    Dark
                  </ThemeLabel>
                  <ThemeLabel
                    $selected={theme === "system"}
                    onClick={() => {
                      setCurentTheme("system");
                    }}
                  >
                    System
                  </ThemeLabel>
                </ThemeBlock>
              </AccountWrapper>
            </li>
            <li
              onClick={() => {
                navigate("/profile");
                setMenuOpen(false);
              }}
            >
              <Person />
              Profile
            </li>
            {/* <li
              onClick={() => {
                navigate("/settings");
                setMenuOpen(false);
              }}
            >
              <GearWideConnected />
              Settings
            </li> */}
            <li
              onClick={() => {
                dispatch(signOut());
                localStorage.removeItem("selectedTeam");
              }}
            >
              <BoxArrowRight />
              Sign Out
            </li>
          </ul>
        </UserMenu>
      )}
    </UserMenuWrapper>
  );
};
